import { beforeEnterCad } from "../method/method";
export default [
  // cad端调用浏览器查看标准
  {
    path: "/standardCad",
    name: "standardCad",
    beforeEnter: beforeEnterCad,
    component: () => import ("@/CommonDP/pages/standard/index.vue"),
    redirect: "/standard/standardTemplate",
    children: [
      {
        path: "/standard/standardTemplate",
        name: "standardTemplateCad",
        component: () => import("@/CommonDP/pages/standard/standardTemplate/index.vue"),
        meta: {
          routeName: "标准模板维护",
          prouteName: "标准模板维护",
          ppname: "应用"
        }
      },
      {
        path: "/standard/standardDrawingFrame",
        name: "standardDrawingFrameCad",
        component: () => import("@/CommonDP/pages/standard/standardDrawingFrame/index.vue"),
        meta: {
          routeName: "标准图框维护",
          prouteName: "标准图框维护",
          ppname: "应用"
        }
      },
      {
        path: "/standard/standardFont",
        name: "standardFontCad",
        component: () => import(/* webpackChunkName: "standardFont" */ "@/CommonDP/pages/standard/standardFont/index.vue"),
        meta: {
          routeName: "字体样式维护",
          prouteName: "字体样式维护",
          ppname: "应用"
        }
      },
      {
        path: "/standard/linearStyle",
        name: "linearStyleCad",
        component: () => import("@/CommonDP/pages/standard/linearStyle/index.vue"),
        meta: {
          routeName: "线型样式维护",
          prouteName: "线型样式维护",
          ppname: "应用"
        }
      },
      {
        path: "/standard/revitMaintenance",
        name: "revitMaintenanceCad",
        component: () => import("@/CommonDP/pages/standard/revitMaintenance/index.vue"),
        meta: {
          routeName: "revit样板维护",
          prouteName: "revit样板维护",
          ppname: "应用"
        }
      },
      {
        path: "/standard/standardLayer",
        name: "standardLayerCad",
        component: () => import("@/CommonDP/pages/standard/standardLayer/index.vue"),
        meta: {
          routeName: "标准图层维护",
          prouteName: "标准图层维护",
          ppname: "应用"
        }
      },
      {
        path: "/standard/templateDirectory",
        name: "templateDirectoryCad",
        component: () => import("@/CommonDP/pages/standard/templateDirectory/index.vue"),
        meta: {
          routeName: "目录模板维护",
          prouteName: "目录模板维护",
          ppname: "应用"
        }
      },
      {
        path: "/standard/collaborationLayer",
        name: "collaborationLayerCad",
        component: () => import("@/CommonDP/pages/standard/collaborationLayer/index.vue"),
        meta: {
          routeName: "协作图层维护",
          prouteName: "协作图层维护",
          ppname: "应用"
        }
      },
      {
        path: "/standard/stamp",
        name: "stampCad",
        component: () => import("@/CommonDP/pages/standard/stamp/index.vue"),
        meta: {
          routeName: "电子图章维护",
          prouteName: "电子图章维护",
          ppname: "应用"
        }
      },
      {
        path: "/standard/signature",
        name: "signatureCad",
        component: () => import("@/CommonDP/pages/standard/signature/index.vue"),
        meta: {
          routeName: "电子签名维护",
          prouteName: "电子签名维护",
          ppname: "应用"
        }
      },
      {
        path: "/standard/frameField",
        name: "frameFieldCad",
        component: () => import("@/CommonDP/pages/standard/frameField/index.vue"),
        meta: {
          routeName: "图框字段",
          prouteName: "图框字段",
          ppname: "应用"
        }
      },
      {
        path: "/standard/printConfiguration",
        name: "printConfigurationCad",
        component: () => import("@/CommonDP/pages/standard/printConfiguration/index.vue"),
        meta: {
          routeName: "打印配置",
          prouteName: "打印配置",
          ppname: "应用"
        },
        children: [
          {
            path: "/standard/configurationFile",
            name: "configurationFileCad",
            component: () => import("@/CommonDP/pages/standard/configurationFile/index.vue"),
            meta: {
              routeName: "绘图仪配置文件",
              prouteName: "绘图仪配置文件",
              pppname: "应用"
            }
          },
          {
            path: "/standard/parameterFile",
            name: "parameterFileCad",
            component: () => import("@/CommonDP/pages/standard/parameterFile/index.vue"),
            meta: {
              routeName: "绘图仪型号参数文件",
              prouteName: "绘图仪型号参数文件",
              pppname: "应用"
            }
          },
          {
            path: "/standard/styleSheet",
            name: "styleSheetCad",
            component: () => import("@/CommonDP/pages/standard/styleSheet/index.vue"),
            meta: {
              routeName: "打印样式表",
              prouteName: "打印样式表",
              pppname: "应用"
            }
          }
        ]
      }
    ]
  },
  // cad端调用浏览器发起提资流程
  {
    path: "/approvalCAD",
    name: "approvalCAD",
    beforeEnter: beforeEnterCad,
    component: () =>
      import ('@/CommonDP/pages/components/launchFlow/approvalCAD.vue')
  },
  // cad端调用浏览器发起提资流程
  {
    path: "/flowDetailCAD",
    name: "flowDetailCAD",
    beforeEnter: beforeEnterCad,
    component: () =>
      import ('@/CommonDP/pages/components/launchFlow/flowDetailCAD.vue')
  },
  // rvt端调用浏览器发起提资流程
  {
    path: "/approvalRVT",
    name: "approvalRVT",
    beforeEnter: beforeEnterCad,
    component: () =>
      import ('@/CommonDP/pages/components/launchFlow/approvalRVT.vue')
  },
  // rvt端调用浏览器发起提资流程
  {
    path: "/flowDetailRVT",
    name: "flowDetailRVT",
    beforeEnter: beforeEnterCad,
    component: () =>
      import ('@/CommonDP/pages/components/launchFlow/flowDetailRVT.vue')
  },
  // cad调用问价夹权限页面
  {
    name: "documentPermission",
    path: "/documentPermission",
    beforeEnter: beforeEnterCad,
    component: () =>
      import ("@/CommonDP/components/documentPermission/indexCad.vue")
  },
  // cad调用审图要点页面
  {
    path: "/checkImgPoint",
    name: "checkImgPoint",
    beforeEnter: beforeEnterCad,
    component: () =>
      import ("@/CommonDP/components/checkImgPoint/indexC.vue")
  },
  // cad调用PDF签章
  {
    path: "/cad/pdfSign",
    name: "pdfSign",
    beforeEnter: beforeEnterCad,
    component: () =>
      import ("@/CommonDP/pages/cad-client/pdfSign/index.vue")
  },
  {
    path: "/exportAnnotation",
    name: "exportAnnotation",
    beforeEnter: beforeEnterCad,
    component: () =>
      import ('@/CommonDP/components/exportAnnotation/index.vue')
  }
];
